import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Paper from "@material-ui/core/Paper";
import { Header } from "../../shared";
import { useHistory } from "react-router-dom";
import { Box } from "@material-ui/core";
import { CommonCss } from "../../services/CommonCss";

import { putRequest } from "../../services/ApiServices";
import { ToastSuccess, ToastError } from "../../services/ToastMsg";
import { LOADING } from '../../action';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  selectedClass: {
    "&:hover": {
      color: "#FF4717",
      border: "2px solid #FF4717",
    },
    width: "120px",
    background: "#FF4717",
    border: "2px solid #FF4717",
    borderRadius: "6px",
    color: "#FFF",
  },
  unSelected: {
    width: "120px",
    border: "2px solid #FF4717",
    borderRadius: "6px",
    color: "#FF4717",
  },
}));
export default function Forgot() {
  const { innerWidth: width, innerHeight: height } = window;
  const classes = useStyles();
  const commonClasses = CommonCss();
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [innerHeight, setInnerHeight] = useState(height);
  const dispatch = useDispatch();
  const isForgot = () => {
    if(email == ""){
      ToastError("mail is required");
      return false;
    }
    
    // history.push({pathname:"/request-sent", email:email });
    sendForgotMail();
    
  };
  const sendForgotMail = () => {
    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      `UserRegistration/ResetPassword/${email}`;
    const data = {};
    dispatch({ type: LOADING, payload: true });
    putRequest(url, data)
    .then((res) => {
      dispatch({ type: LOADING, payload: false });
      history.push({pathname:"/request-sent", email:email });
      ////console.log(res);
    })
    .catch((error) => {
      dispatch({ type: LOADING, payload: false });
      // ToastError(error.response.data.message);
      ToastError("Incorrect mail address");
    });
  }
  ////console.log('forgot');
  return (
    <Box overflowX="hidden">
      <Header />
      <Box bgcolor="#1A1A31" height={innerHeight - 123 + "px"}>
        <Box className={commonClasses.navContainer} height={1}>
          <Box
            display="flex"
            className={commonClasses.alignItemsStretch}
            height={1}
          >
            <Box width={0.5}>
              <Box pt={3} width={0.6}>
                <Paper className="loginpg"
                  elevation={3}
                  
                >
                  <Box display="flex" alignItems="center" height="400px">
                    <Box display="block">
                      <Box component="h1" mt={0} fontWeight="500">
                        Forgot Password?
                      </Box>
                      <form className={classes.form} noValidate>
                        <Box component="span" fontSize={14} fontWeight="500">
                          Enter your email and we will send a reset link
                        </Box>

                        <TextField
                          variant="outlined"
                          margin="dense"
                          required
                          fullWidth
                          id="email"
                          //label="Email Address"
                          name="email"
                          autoComplete="email"
                          placeholder="johndoe@companyname.com"
                          autoFocus
                          onChange={(e) => setEmail(e.target.value)}
                        />
                         <Box display="flex">
                      <Box fontWeight="400">Use company email/domain only</Box>
                    </Box>
                        
                      </form>

                      <Box
                        mt={3}
                        display="flex"
                        className={commonClasses.justifyContentBetween}
                      >
                        <Box>
                          <ButtonGroup disableElevation>
                            <Button   mr={3}
                              className={classes.selectedClass}
                              onClick={() => isForgot()}
                            >
                              Submit
                            </Button>
                            <Button
                              className="cancel-btn"
                              
                              onClick={() => {
                                history.push("/sign-in");
                              }}
                            >
                              Cancel
                            </Button>
                          </ButtonGroup>
                        </Box>
                      </Box>
                    </Box>{" "}
                  </Box>
                </Paper>
              </Box>
            </Box>
            <Box width={0.5}>
              <Box
                display="flex"
                justifyContent="flex-end"
                height={1}
                alignItems="flex-end"
              >
                <Box
                  component="img"
                  src={
                    process.env.REACT_APP_CUSTOMER_PORTAL_URL +
                    "assets/images/arrows.png"
                  }
                  mb={16}
                  mr={5}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
